import dayjs from 'dayjs'

const mapData = list => {
    const qualificationData = {}
    list.forEach(v => (qualificationData[v.qualificationName] = v))
    return qualificationData
}

// 处理身份证证件信息
const dealWithCertificate = list => {
    if (Array.isArray(list) && list.length > 0) {
        const obj = mapData(list)
        const qualificationObj = {}
        Object.keys(obj).forEach(k => {
            switch (k) {
            case '身份证（人像面）':
                qualificationObj.idCardFileId = obj[k].fileId || ''
                qualificationObj.idCardFileName = obj[k].fileName || ''
                qualificationObj.idCardFileUrl = obj[k].fileUrl || ''
                qualificationObj.idCard = obj[k].certificateNo || '' // 身份证号码
                break
            case '身份证（国徽面）':
                qualificationObj.idCardBottomSideFileId = obj[k].fileId || ''
                qualificationObj.idCardBottomSideFileName = obj[k].fileName || ''
                qualificationObj.idCardBottomSideFileUrl = obj[k].fileUrl || ''
                qualificationObj.idCardStartDate = obj[k].certificateBeginDate
                    ? dayjs(obj[k].certificateBeginDate).format('YYYY-MM-DD')
                    : '' // 身份证起始日期
                qualificationObj.idCardEndDate = obj[k].certificateEndDate
                    ? dayjs(obj[k].certificateEndDate).format('YYYY-MM-DD')
                    : '' // 身份证结束日期
                break
            case '驾驶证':
                qualificationObj.drivingLicenceFileId = obj[k].fileId || ''
                qualificationObj.drivingLicenceFileName = obj[k].fileName || ''
                qualificationObj.drivingLicenceFileUrl = obj[k].fileUrl || ''
                qualificationObj.drivingLicence = obj[k].certificateNo || '' // 驾驶证号
                qualificationObj.driveStartDate = obj[k].certificateBeginDate
                    ? dayjs(obj[k].certificateBeginDate).format('YYYY-MM-DD')
                    : '' // 驾驶证起始日期
                qualificationObj.driveEndDate = obj[k].certificateEndDate
                    ? dayjs(obj[k].certificateEndDate).format('YYYY-MM-DD')
                    : '' // 驾驶证结束日期
                break
            case '从业资格证':
                qualificationObj.empCertificateFileId = obj[k].fileId || ''
                qualificationObj.empCertificateFileName = obj[k].fileName || ''
                qualificationObj.empCertificateFileUrl = obj[k].fileUrl || ''
                qualificationObj.empCertificate = obj[k].certificateNo || '' // 从业资格证号
                qualificationObj.empCertificateEndDate = obj[k].certificateEndDate
                    ? dayjs(obj[k].certificateEndDate).format('YYYY-MM-DD')
                    : '' // 从业资格证到期日期
                break
            case '委派函':
                qualificationObj.delegateFileId = obj[k].fileId || ''
                qualificationObj.delegateFileName = obj[k].fileName || ''
                qualificationObj.delegateFileUrl = obj[k].fileUrl || ''
                qualificationObj.delegateStartTime = obj[k].certificateBeginDate
                    ? dayjs(obj[k].certificateBeginDate).format('YYYY-MM-DD')
                    : '' // 委派函起始日期
                qualificationObj.delegateEndTime = obj[k].certificateEndDate
                    ? dayjs(obj[k].certificateEndDate).format('YYYY-MM-DD')
                    : '' // 委派函结束日期
                break
            }
        })
        return qualificationObj
    } else {
        return {}
    }
}

// 处理通过输入身份证后识别系统已存在的数据
export const dealWithSearchResultParams = r => {
    if (r.idCard) {
        return { ...r, ...dealWithCertificate(r.qualificationInfoList) }
    } else {
        return r
    }
}

export const pickerOptionsDelegateStartDate = ctx => {
    return {
        disabledDate: time => {
            if (ctx.formData.delegateEndTime) {
                return time.getTime() >= new Date(ctx.formData.delegateEndTime).getTime()
            }
        },
    }
}

export const pickOptionsDelegateEndDate = ctx => {
    return {
        disabledDate: time => {
            if (ctx.formData.delegateStartTime) {
                return time.getTime() <= new Date(ctx.formData.delegateStartTime).getTime()
            }
        },
    }
}

export const pickerOptionsDrivingLicenceStart = ctx => {
    return {
        disabledDate: time => {
            return time.getTime() >= new Date().getTime()
        },
    }
}

export const pickerOptionsDrivingLicenceEnd = ctx => {
    return {
        disabledDate: time => {
            if (ctx.formData.driveStartDate) {
                return time.getTime() <= new Date(ctx.formData.driveStartDate).getTime()
            }
        },
    }
}
